import useMutation from "src/hooks/useMutation";

export default function useDebtReportDelete(id) {
  return useMutation({
    path: `/api/v1/reports/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/reports`,
      shouldRevalidate: true,
    },
  });
}
